var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c("m-maps-set-audience-popup", {
                ref: "m-maps-set-audience-popup",
              }),
              _c("popup-edit-version", { ref: "popup-edit-version" }),
              _c("popup-edit-string", { ref: "popup-edit-string" }),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-2" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text pl-5 pr-3",
                              attrs: {
                                disabled: !_vm.ifCanImportTmx(),
                                loading: _vm.importingMap,
                                color: "blue",
                                elevation: "0",
                              },
                              on: { click: _vm.onPressImport },
                            },
                            [
                              _vm._v(" Import *.TMX "),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-database-import-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c("input", {
                            ref: "uploader",
                            staticClass: "d-none",
                            attrs: { type: "file", accept: ".tmx" },
                            on: { change: _vm.onFileChanged },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "m-maps-list",
                        {
                          on: {
                            "show-popup-edit-version": _vm.showEditVersionPopup,
                            "show-m-maps-set-audience-popup":
                              _vm.showEditAudiencePopup,
                            "show-popup-edit-custom-name":
                              _vm.showEditCustomName,
                          },
                        },
                        [_vm._v(">")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }